'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _UIIcon = require('./UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'UIIconHolder',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: _extends({
    backgroundColor: _react.PropTypes.string,
    borderColor: _react.PropTypes.string,
    borderRadius: _react.PropTypes.string,
    borderStyle: _react.PropTypes.oneOf(['solid', 'double', 'dashed', 'dotted', 'initial', 'inherit', 'unset']),
    borderWidth: _react.PropTypes.number,
    classname: _react.PropTypes.string,
    innerClassName: _react.PropTypes.string,
    padding: _react.PropTypes.number,
    rotate: _react.PropTypes.number,
    size: _react.PropTypes.number,
    style: _react.PropTypes.object,
    rotateLock: _react.PropTypes.bool,
    innerStyles: _react.PropTypes.object,
    _fromUIIconCircle: _react.PropTypes.bool
  }, _UIIcon2.default.propTypes),

  getDefaultProps: function getDefaultProps() {
    return {
      padding: 0.5,
      rotate: 0,
      borderStyle: 'solid',
      borderWidth: 0
    };
  },
  getBorderRadius: function getBorderRadius(borderRadius) {
    if (borderRadius === '50%' && !this.props._fromUIIconCircle) {
      _devLogger2.default.warn({
        message: "If you're putting an icon in a circle you should use UIIconCircle. It's better at centering",
        key: 'UIIConHolder-' + this.props.name
      });
    }
    return { borderRadius: borderRadius };
  },
  getRotation: function getRotation(rotate, rotateLock) {
    var innerRotation = 0;

    if (!rotateLock) {
      innerRotation = -1 * rotate;
    }

    return {
      outer: 'rotate(' + rotate + 'deg)',
      inner: 'rotate(' + innerRotation + 'deg)'
    };
  },
  getTransformationOuter: function getTransformationOuter(rotate, rotateLock) {
    var outterRotation = this.getRotation(rotate, rotateLock).outer;
    return { transform: '' + outterRotation };
  },
  getTransformationInner: function getTransformationInner(rotate, rotateLock) {
    var innerRotation = this.getRotation(rotate, rotateLock).inner;
    var xHeightToCenterOffset = 'translateY(-6.3%)';
    return { transform: innerRotation + ' ' + xHeightToCenterOffset };
  },
  getPadding: function getPadding(padding) {
    return {
      padding: padding + 'em'
    };
  },
  getSize: function getSize(size) {
    return { fontSize: size + 'px' };
  },
  render: function render() {
    var _props = this.props,
        ___fromUIIconCircle = _props._fromUIIconCircle,
        backgroundColor = _props.backgroundColor,
        borderColor = _props.borderColor,
        borderRadius = _props.borderRadius,
        borderStyle = _props.borderStyle,
        borderWidth = _props.borderWidth,
        className = _props.className,
        color = _props.color,
        innerClassName = _props.innerClassName,
        innerStyles = _props.innerStyles,
        name = _props.name,
        padding = _props.padding,
        rotate = _props.rotate,
        rotateLock = _props.rotateLock,
        size = _props.size,
        style = _props.style,
        rest = _objectWithoutProperties(_props, ['_fromUIIconCircle', 'backgroundColor', 'borderColor', 'borderRadius', 'borderStyle', 'borderWidth', 'className', 'color', 'innerClassName', 'innerStyles', 'name', 'padding', 'rotate', 'rotateLock', 'size', 'style']);

    var outerClassNames = (0, _reactUtils.classNames)(className, 'private-icon-holder__outer');
    var innerClassNames = (0, _reactUtils.classNames)(innerClassName, 'private-icon-holder__inner');

    return _react2.default.createElement(
      'span',
      _extends({}, rest, {
        className: outerClassNames,
        style: _extends({}, style, this.getTransformationOuter(rotate, rotateLock), this.getPadding(padding), this.getSize(size), this.getBorderRadius(borderRadius), {
          backgroundColor: backgroundColor,
          borderColor: borderColor,
          borderStyle: borderStyle,
          borderWidth: borderWidth
        })
      }),
      _react2.default.createElement(_UIIcon2.default, {
        className: innerClassNames,
        color: color,
        name: name,
        size: size,
        style: _extends({}, innerStyles, this.getTransformationInner(rotate, rotateLock))
      })
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/icon/UIIconHolder.js
// module id = 295
// module chunks = 0